import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface HoldFollowUpDialogData {
  followUpDate?: string | Date;
}

@Component({
  selector: 'app-hold-follow-up-dialog',
  template: `
    <h2 mat-dialog-title>HOLD / RX FOLLOW-UP DATE</h2>
    <mat-dialog-content>
      <p class="hold-follow-up-message">
        Prefills to 48 hours from now. Accept this date or choose a later date
        if the customer needs more time.
      </p>
      <mat-form-field appearance="fill" class="hold-follow-up-field">
        <mat-label>FOLLOW-UP DATE</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="followUpDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!followUpDate.value"
        (click)="confirm()"
      >
        SAVE
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .hold-follow-up-message {
        margin: 0 0 16px;
        font-size: 13px;
        line-height: 1.4;
      }
      .hold-follow-up-field {
        width: 100%;
      }
    `,
  ],
})
export class HoldFollowUpDialogComponent {
  followUpDate = new FormControl(null);

  constructor(
    public dialogRef: MatDialogRef<HoldFollowUpDialogComponent, Date | null>,
    @Inject(MAT_DIALOG_DATA) public data: HoldFollowUpDialogData
  ) {
    this.followUpDate.setValue(this.resolveInitialDate(data?.followUpDate));
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    const value = this.followUpDate.value;
    if (!value) {
      return;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return;
    }
    this.dialogRef.close(date);
  }

  private resolveInitialDate(value?: string | Date): Date {
    if (value) {
      const parsed = value instanceof Date ? value : new Date(value);
      if (!isNaN(parsed.getTime())) {
        return parsed;
      }
    }
    return new Date(Date.now() + 48 * 60 * 60 * 1000);
  }
}
